import React from "react";
import styled, { css } from "styled-components/macro";
import { toast } from "react-toastify";
// import { Col } from "../general";
const DialBtn = styled.div`
  display: inline-block;
  text-align: center;
  background: #e5e5e5;
  width: 70px;
  height: 70px;
  line-height: 73px;
  font-size: 2.3rem;
  color: #000;
  border-radius: 50%;
`;
const NumberBoxStyle = styled.div`
  flex: 0 0 100%;
  max-width: 100%;
  padding: 20px 0;
  & h3 {
    text-align: center;
    font-size: ${({ status }) => (status ? "1.3rem" : "3rem")};
    line-height: 40px;
    height: 40px;
    margin: 0;
    color: ${({ loading }) => (loading ? "#929292" : "#5a5a5a")};
    letter-spacing: 2px;
  }
  & span {
    text-align: center;
    font-size: 1.3rem;
    color: #5f5f5f;
    line-height: 20px;
    text-align: center;
    display: block;
  }
`;

const NumberBox = ({ name, children, loading, setVal }) => {
  const pasteNumberFromclipBoard = async () => {
    if (window.navigator.clipboard) {
      if (!children || children === -1) {
        try {
          const text = await window.navigator.clipboard.readText();
          const Number = text.replace(/ /g, "");
          if (isNaN(Number) && Number.length !== 11) {
            toast.error("شماره کپی شده باید 11 رقم و شامل اعداد باشد");
          } else {
            setVal(Number);
          }
        } catch (error) {
          toast.warn(
            "قابلیت جایگذاری متن در مرورگر شما وجود ندارد یا دسترسی آن توسط شما رد شده"
          );
        }
      }
    }
  };
  return (
    <NumberBoxStyle loading={loading} status={children < 0}>
      <h3 onClick={pasteNumberFromclipBoard}>
        {children < 0 ? "شماره ای وجود ندارد" : children}
      </h3>
      {name ? <span>{name}</span> : null}
    </NumberBoxStyle>
  );
};
const CallCol = styled.div`
  flex: 0 0 100%;
  max-width: 100%;
  text-align: center;
  order: 13;
  position: relative;
`;
const RemoveNumber = styled.div`
  background: #e5e5e5;
  color: #000;
  width: 25px;
  line-height: 25px;
  border-radius: 3px;
  padding: 0 3px;
  position: absolute;
  right: 30px;
  top: calc(50% - 10px);
  & > i {
    display: block;
    line-height: inherit;
    text-align: center;
    font-size: 1.2rem;
  }
  &:before {
    content: "";
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 12px 12px 12px 0;
    border-color: transparent #e5e5e5 transparent transparent;
    position: absolute;
    right: 100%;
  }
`;
const DialIcons = styled.i`
  display: block;
  line-height: inherit;
  color: var(--color1);
`;
export { DialBtn, NumberBox, DialIcons };
